/*
 * @Author: 梁宏平
 * @FilePath: /mall-fe/src/api/expose.ts
 * @Description: 曝光栏api
 *
 */
// 引入全局http请求封装
import { fetch } from 'libs/fetch';
/**
 * @description: 获取房源列表
 * @param {Object} option 查询参数
 * @return {Array<Object>} 房源信息列表
 */
export function searchExposeList(json) {
  return fetch(`/api/ifs/v1/basisViolationRecord/searchExposeList`, {
    json,
    method: 'POST',
  });
}


/**
 * @description: 商城发布违规记录
 * @param {Object} option 查询参数
 * @return {Object} 违规记录
 */
export function releaseViolationRecord(json) {
    return fetch(`/api/ifs/v1/basisViolationRecord/releaseViolationRecord`, {
        json,
        method: 'POST',
    });
}

/**
 * @description:  查询供应商列表信息
 * @param {Object} option 查询参数
 * @return {Object} 供应列表信息
 */
export function querySupplierList(json) {
    return fetch(`/api/mall/v1/supplier/search`, {
        json,
        method: 'POST',
    });
}

/**
 * @description:  保存浏览记录
 * @param {Object} option 查询参数
 * @return {Object} 供应列表信息
 */
export function tractUserVisitRecord(json) {
  return fetch(`/api/ifs/v1/basisViolationRecord/saveBasisViolationExposeUserHistoryRecord`, {
      json,
      method: 'POST',
  });
}

/**
 * @description:  获取总的曝光记录
 * @param {Object} option 查询参数
 * @return {Object} 供应列表信息
 */
export function getUserVisitRecordCount(json) {
  return fetch(`/api/ifs/v1/basisViolationRecord/selectBasisViolationExposeUserHistoryRecordCount`, {
      json,
      method: 'POST',
  });
}

/**
 * @description:  是否显示曝光栏按钮
 * @param {Object} option 查询参数
 * @return {Object} 供应列表信息
 */
export function isShowExposeBtn(json) {
  return fetch(`/api/ifs/v1/basisViolationRecord/isShowExposeBtn`, {
      json,
      method: 'POST',
  });
}

/**
 * @description:  获取最新用户记录
 * @param {Object} option 查询参数
 * @return {Object} 供应列表信息
 */
export function fetchLatestExposeState(json) {
  return fetch(`/api/ifs/v1/basisViolationRecord/fetchLatestExposeState`, {
      json,
      method: 'POST',
  });
}

/**
 * @description:  更新曝光栏状态
 * @param {Object} option 查询参数
 * @return {Object} 供应列表信息
 */
export function updateExposeState(json) {
  return fetch(`/api/ifs/v1/basisViolationRecord/updateExposeState`, {
      json,
      method: 'POST',
  });
}